<template>
  <div :style="seckillBg" class="seckill">
    <van-tabs
      v-if="cateNameList && cateNameList.length > 0"
      v-model="cateName"
      animated
      type="card"
      @click="onTabClick"
    >
      <van-tab
        v-for="(name, index) of cateNameList"
        :key="index"
        :name="name"
        :title="name"
      >
      </van-tab>
    </van-tabs>
    <van-list
      ref="goods_list_ref"
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      :offset="100"
      @load="getGoodsList"
    >
      <div>
        <div v-for="(item, index) in goodsList" :key="index">
          <goods-unit
            :goods-id="item.goodsId"
            :goods-style="11"
            :head-image="item.headImage"
            :name="item.name"
            :price="item.price"
            :spec="item.spec"
            :tags="JSON.parse(item.tags)"
            :topic-id="10"
          ></goods-unit>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { wx_get_goods_list_by_topic, getMultipleGoods } from "@/api/goods-api";
import { mall_util_order_buy_goods } from "@/util/orders";
import GoodsUnit from "@/components/common/goods-unit";
import GoodsSpec from "@/components/common/goods-spec";
import { Dialog } from "vant";

export default {
  name: "seckill",
  components: {
    GoodsUnit,
    GoodsSpec,
  },

  data() {
    return {
      seckillBg: {
        background:
          "#c9060c url(" +
          require("../../../public/images/other/seckill-bg.png") +
          ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto",
      },
      goodsList: [],
      cateNameList: [],
      visibleSpecWin: false,
      goodsDetail: {},
      visiblePrice: 1,
      error: false,
      loading: false,
      finished: false,
      finishedText: "没有更多了 L",
      cateName: "",
      pi: 0,
      haveData: true,
    };
  },

  created() {
    getMultipleGoods().then((res) => {
      if (!res.data) {
        this.loading = false;
        this.finished = true;

        budo_log.info("#77 go bind card");

        Dialog({
          message: "没有适用的卡券,请先绑定卡券",
          beforeClose: () => {
            this.$router.replace({ path: "/bind-card" });
          },
        });

        return;
      }

      this.cateNameList = res.data.cates;
      if (this.cateNameList && this.cateNameList.length > 0) {
        this.cateName = this.cateNameList[0];
        this.goodsList = res.data.goods.records;
        this.finished = false;
      }
    });
    this.pi = 1;
  },

  methods: {
    onTabClick(name) {
      budo_log.info("#98", name);
      this.pi = 0;
      this.cateName = name;
      this.goodsList = [];

      this.loading = true;
      this.finished = false;
      if (this.cateNameList && this.cateNameList.length > 0) {
        this.getGoodsList();
      }

      //this.$refs.goods_list_ref.load();
    },

    getGoodsList() {
      if (this.cateNameList && this.cateNameList.length > 0) {
        this.finishedText = "加载中 D ...";
        budo_log.info("#113", this.pi);
        this.pi++;

        //促销标签商品
        getMultipleGoods(this.pi, 10, this.cateName)
          .then((res) => {
            if (!res.data) {
              this.loading = false;
              this.finished = true;
              this.haveData = false;
              return;
            }
            budo_log.info("#125", res);
            this.goodsList = this.goodsList.concat(res.data.goods.records);

            if (this.goodsList.length >= res.data.goods.total) {
              this.finishedText = "没有更多了 M";
              this.finished = true;
            }

            if (res.data.total === 0) {
              this.finishedText = "看看其它的吧 E";
              this.finished = true;
            }

            this.loading = false;
          })
          .catch((error) => {
            budo_log.info("#144 ", error);

            this.finishedText = "没有更多了 N";
            this.finished = true;
            this.loading = false;
            this.error = true;
          });
      } else {
        this.loading = false;
        this.finished = true;
      }
    },

    init() {
      this.getList();
    },

    handleClick(val) {
      this.$router.replace({
        path: `/goods-detail?goodsId=${val.id}`,
      });
    },

    handleBuy(val) {
      if (val.multipleSpec) {
        this.goodsDetail = {
          ...val,
        };
        this.$nextTick(() => {
          this.showSpec();
        });
      } else {
        mall_util_order_buy_goods(val.id, 1, false);
      }
    },

    showSpec() {
      this.visibleSpecWin = true;
      this.$refs.spec.initSpecInfo();
    },

    async getList() {
      const topicId = 10;
      let resp = await wx_get_goods_list_by_topic(topicId, "", 1, 10);
      if (resp.code === 0) {
        resp.data &&
          Array.isArray(resp.data.records) &&
          (this.list = resp.data.records.map((item) => {
            return {
              id: item.goodsId,
              name: item.name,
              price: item.price,
              headImage: item.headImage,
              adsTitle: item.adsTitle || "  ",
              tags: JSON.parse(item.tags),
              cateCode: item.cateCode || "",
              identityAuth: item.identityAuth,
              cateId: item.cateId,
              spec: item.spec,
              multipleSpec: !!item.spec,
              isSeckill: true,
            };
          }));
      }
    },

    forbidBack() {
      window.history.pushState("forward", null, "#");
      window.history.forward(1);
    },
  },

  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.forbidBack, false);
      this.forbidBack();
    }
  },

  destroyed() {
    window.removeEventListener("popstate", this.forbidBack, false);
  },
};
</script>
<style lang="scss" scoped>
.seckill {
  min-height: 100vh;
  padding: 300px 20px 70px;

  .van-card {
    margin-top: 8px;
    border-radius: 10px;

    .van-card__title {
      font-size: 16px;
    }

    .van-card__desc {
      margin: 10px 0;
      color: #808080;
    }

    .target {
      color: #ff4200;
      background: #ffe5dc;
      padding: 5px 7px;
    }

    .van-card__footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 88px;
    }

    .price-icon {
      width: 18px;
      height: 18px;
      margin-right: 1px;
    }

    .van-button--small {
      padding: 0 15px;
    }

    .van-icon-cart-o {
      font-size: 14px;
      float: left;
      margin-right: 5px;
    }
  }
}
</style>
